import { TranslatePipe } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";

import { ChangeDetectionStrategy, Component, computed, inject, signal } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MatDialogRef } from "@angular/material/dialog";

import { Customer } from "../../../apis/networkdashboard/rest/models";
import { AuthService } from "../../../services/authservice";

type CustomerWithSearchKey = Customer & { searchKey: string };

@Component({
  selector: "choose-customer-dialog",
  templateUrl: "choose-customer-dialog.html",
  styleUrls: ["choose-customer-dialog.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AngularSvgIconModule, FormsModule, TranslatePipe],
})
export class ChooseCustomerDialog {
  protected activeTab = 0;
  protected activeTabDialog = 0;
  private customers = computed(() =>
    this.auth.customers().map((customer) => ({
      ...customer,
      searchKey: `${customer.name.toLowerCase()} ${customer?.abbreviation?.toLowerCase() ?? ""}`.trim(),
    })),
  );
  protected searchValue = signal("");
  protected filteredCustomers = computed(() => {
    const needle = this.searchValue().toLowerCase();
    return this.customers()
      .filter((customer) => customer.searchKey.includes(needle))
      .sort(_compareCustomers);
  });

  private readonly auth = inject(AuthService);
  private readonly dialogRef = inject(MatDialogRef<ChooseCustomerDialog>);

  switchTab(tab: number) {
    this.activeTab = tab;
  }

  switchTabDialog(tabdialog: number) {
    this.activeTabDialog = tabdialog;
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  switchCustomer(guid: string): void {
    this.auth.switchViewingCustomer(guid, "/");
  }
}

function _compareCustomers(customer1: CustomerWithSearchKey, customer2: CustomerWithSearchKey): number {
  return customer1.name.localeCompare(customer2.name);
}
